function initFormFieldPhoneNumber(){
  const inputsWithMask = $('.form-field-phone-number[data-mask]');

  inputsWithMask.each(function () {
    const maskObject = $(this).data('mask');
    $(this).mask(maskObject.mask, {
      clearIfNotMatch: false,
      translation: {
        '9': {pattern: /\d/}
      }
    });
  });
};

$(function () {
  initFormFieldPhoneNumber();
});

